(ns teamoesterreich.admin-mode.data.organisation
  (:require [clojure.walk]
            [goog.json :as json]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.ajax :as ajax]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.download :as h-download]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as v-state]))



(defn get-first-main [mains main]
  (if main
    (reduce (fn [c k] (if (or (= k main) (re-matches (re-pattern (str k)) (str main))) k c)) "" mains)
    ""))
(defn get-first-dep [deps dest]
  (if dest
    (reduce (fn [c k] (if (or (= k dest) (re-find (re-pattern k) (str dest))) k c)) "" deps)
    ""))


(defn get-first-fit-main [mains orgId]
  (println "#########################################  get-first-main ***** " (clj->js mains))
  (if orgId
    (reduce (fn [c [k main]]
              (println "######################################### get-first-main CHECK " main)
              (if (or (= (:organisation-key main) orgId) (re-matches (re-pattern (or (:organisation-orgFilter main) "##")) orgId)) (:organisation-key main) c)) "" mains)
    ""))

(defn get-first-fit-dep [deps orgId]
  (if orgId
    (reduce (fn [c [k dep]]
              ;(println "######################################### get-first-main CHECK " dep)
              (if (or (= (:organisation-key dep) orgId) (re-matches (re-pattern (or (:organisation-orgFilter dep) "##")) orgId)) (:organisation-key dep) c)) "" deps)
    ""))

(defn get-dep-4-dest [deps dest]
  (if dest
    (reduce (fn [c [k n]]
              ;(js/console.log "get-first-dep " (str k) " d:" (str dest) "+++ " (re-matches (re-pattern (str k)) (str dest)) )
              (if (or (= k dest) (re-matches (re-pattern (str k)) (str dest))) n c)) "" deps)
    ""))


(defn >organisation-edit [key obj finished-fn]
  (ajax/auth-patch> (backend/get-auth) (str backend/BASE_URL "/organisation/" key)
                    (ajax/serialize (merge obj
                                           {:organisation-key key}))
                    finished-fn))
(defn >organisation-delete [key finished-fn]
  (ajax/auth-delete> (backend/get-auth) (str backend/BASE_URL "/organisation/" key) finished-fn))

(defn >organisation-new [key finished-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/organisation")
                   (ajax/serialize (merge {:organisation-key  key
                                           :organisation-name (str "Dienststelle-" key)}))
                   finished-fn))

(defn <get-organisation-list [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/organisation")
                  (fn [r-list status]
                    ;(log/debug "get-blog done" r-list status)
                    (when (= status 200)
                      (done-fn
                        (into {} (map (fn [e] [(get e "organisation-key") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                        )))))

(defn <get-organisation-by-key [key done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/organisation/" key)
                  (fn [r-list status]
                    (log/debug "get-blog done" r-list status " +++ " (js->clj (json/parse r-list)))
                    (when (= status 200)
                      (done-fn
                        (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                        )))))


;(in-ns 'teamoesterreich.admin-mode.data.organisation)
;(get-in @v-state/app-state [:organisations])

(defn get-store-organisations [& [force?]]
  (when (or (not (get-in @v-state/app-state [:organisations])) force?)
    (<get-organisation-list (fn [org]
                              (log/debug "get-store-organisations result " (clj->js org))
                              (swap! v-state/app-state assoc :organisations org)
                              ))))


(defn get-org-filter-list_ [org-list & [orgId-filter]]
  (map (fn [[i o]] [(:organisation-orgFilter o) (:organisation-name o)])
       (filter (fn [[i o]]
                 (and
                   (= (:organisation-level o) "2")
                   (or (not orgId-filter)
                       (re-find (re-pattern orgId-filter) (:organisation-key o)))
                   ))
               (sort-by :organisation-key org-list))))

(defn get-main-filter-list [org-list & [orgId-filter]]
  (into [] (concat [[".*" "Alle"]]
                   (mapv (fn [[i o]] [(:organisation-orgFilter o) (:organisation-name o)])
                         (filter (fn [[i o]]
                                   (and
                                     (= (:organisation-level o) "1")
                                     (or (not orgId-filter)
                                         (re-find (re-pattern orgId-filter) (:organisation-key o)))
                                     ))
                                 (sort-by :organisation-key org-list))))))
(defn get-lv-filter-list [org-list & [orgId-filter]]
  (into [] (concat [[".*" "Alle"] ["2" "TempOrg"]]
                   (mapv (fn [[i o]] [(:organisation-orgFilter o) (:organisation-name o)])
                         (filter (fn [[i o]]
                                   (and
                                     (= (:organisation-level o) "2")
                                     (or (not orgId-filter)
                                         (re-find (re-pattern orgId-filter) (:organisation-key o)))
                                     ))
                                 (sort-by :organisation-key org-list))))))


(defn get-dest-list [org-list & [orgId-filter]]
  (map (fn [[i o]] [(:organisation-orgFilter o) (:organisation-name o)])
       (filter (fn [[i o]]
                 (and
                   (= (:organisation-level o) "3")
                   (or (not orgId-filter)
                       (re-find (re-pattern orgId-filter) (:organisation-key o)))
                   ))
               (sort-by :organisation-key org-list))))

(defn get-main-multi-filter-list [org-list & [orgId-filters]]
  (map (fn [[i o]] [(:organisation-key o) o])
       (filter (fn [[i o]]
                 (and
                   (= (:organisation-level o) "1")
                   (reduce
                     (fn [c orgId-filter]
                       (or c
                           (re-matches (re-pattern orgId-filter) (:organisation-key o))
                           ))
                     false
                     orgId-filters)
                   ))
               (sort-by :organisation-name org-list))))

(defn get-org-multi-filter-list [org-list & [orgId-filters]]
  (map (fn [[i o]] [(:organisation-orgFilter o) o])
                (filter (fn [[i o]]
                          (and
                            (= (:organisation-level o) "2")
                            (reduce
                              (fn [c orgId-filter]
                                (or c
                                    (re-matches (re-pattern orgId-filter) (:organisation-key o))
                                    ))
                              false
                              orgId-filters)
                            ))
                        (sort (fn [[i o]] (:organisation-name o)) org-list)))
  )

(defn get-dest-multi-filter-list [org-list & [orgId-filters]]
  (map (fn [[i o]] [(:organisation-orgFilter o) o])
       (filter (fn [[i o]]
                 (and
                   (= (:organisation-level o) "3")
                   (or (not orgId-filters)
                       (reduce
                         (fn [c orgId-filter]
                           (or c (re-matches (re-pattern orgId-filter) (:organisation-key o))))
                         false
                         orgId-filters))
                   ))
               (sort-by :organisation-name org-list))))

(defn get-all-multi-filter-list [org-list & [orgId-filters]]
  (map (fn [[i o]] [(:organisation-orgFilter o) (:organisation-name o)])
       (filter (fn [[i o]]
                 (and
                   (or (not orgId-filters)
                       (reduce
                         (fn [c orgId-filter]
                           (or c (re-find (re-pattern orgId-filter) (:organisation-key o))))
                         false
                         orgId-filters))
                   ))
               (sort-by :organisation-name org-list))))



(defn get-department-for-key [mask dep-mask-list]
  (or (get dep-mask-list mask)
      (reduce (fn [c [m n]]
                ;(println ":organisationDepartment" mask " -- " [c [m n]])
                (if (and (> (count m)) (re-find (re-pattern m) mask))
                  n c)) "-" (sort-by #(count (first %)) dep-mask-list))))

(defn csv-list []
  (h-download/download-blob (backend/get-auth) (str backend/BASE_URL "/organisation/csv") "Organisationen.csv"))


(defn get-reply-address-list [me org-list]
  (let [emails (distinct (filter (fn [email] (re-matches (re-pattern (txt/txt :core :replyTo_regex "##")) email))
                                 (reduce
                                   (fn [c [_ o]]
                                     ;(log/debug "+++get-reply-address-list ++ " (:organisation-orgFilter o) "=" (str meOrgId)
                                     ;           (if (re-matches (re-pattern (or (:organisation-orgFilter o) "##")) (str meOrgId)) "ok" "nok")
                                     ;           (clj->js c))
                                     (if (re-matches (re-pattern (or (:organisation-orgFilter o) "##")) (str (:user-orgId me)))
                                       (concat c
                                               [(:organisation-email o)
                                                (:organisation-lrEmail o)
                                                (:organisation-tafelEmail o)
                                                (:user-email me)])
                                       c
                                       ))
                                   []
                                   org-list)))]
    ;(log/debug "####################################  get-reply-address-list" meOrgId (clj->js emails))
    (concat [(txt/txt :core :replyTo_fallback)]
            emails
            )))
(defn get-prefered-reply-address-list [me org-list template-group]
  (let [prefered (case template-group
                   "lebensretter" :organisation-lrEmail
                   "tafel" :organisation-tafelEmail
                   :organisation-email
                   )


        emails (reduce
                 (fn [c [_ o]]
                   ;(log/debug "+++get-prefered-reply-address-list ++ " (:organisation-orgFilter o) "=" (str (:user-orgId me))
                   ;           (clj->js c))
                   (if (and
                         (re-matches (re-pattern (or (:organisation-orgFilter o) "##")) (str (:user-orgId me)))
                         (re-matches (re-pattern (txt/txt :core :replyTo_regex "##")) (get o prefered))
                         (> (:organisation-level o) (or (first c) 0)))
                     [[(:organisation-level o) (get o prefered)]]
                     c
                     ))
                 []
                 org-list)]
    ;(log/debug "####################################  get-prefered-reply-address-list" (clj->js emails) (second (first emails)))
    (or (second (first emails)) (txt/txt :core :replyTo_fallback))
    ))


